import React, { useState } from "react"

import GraphQLProvider from "../../providers/GraphQLProvider"

import ClientChronology from "./ClientChronology"
import ClientOpenPackages from "./ClientOpenPackages"
import ClientPageView from "./ClientPageView"

const Overview = ({ client: clientProp, upcomingAppointments, clientNotesEnabled, multipleIntakeFormsEnabled }) => {
  const [client] = useState(clientProp)

  return (
    <ClientPageView
      client={client}
      upcomingAppointments={upcomingAppointments}
      path={`/portal/clients/${client.id}`}
      clientNotesEnabled={clientNotesEnabled}
      multipleIntakeFormsEnabled={multipleIntakeFormsEnabled}>
      <ClientOpenPackages clientId={client.id} />
      <ClientChronology client={client} clientNotesEnabled={clientNotesEnabled} />
    </ClientPageView>
  )
}

export default function ClientOverview(props) {
  return (
    <GraphQLProvider>
      <Overview {...props} />
    </GraphQLProvider>
  )
}
